export const noActiveVehiclesExclusionChatCodes = [
  'RPVRQ',
  'RPVIP',
  'ARCRR',
  'ARCRP',
  'LGCPG',
  'SLCPG',
  'DFL',
  'MIG',
  'FIF',
  'IFS',
  'IFC',
  'ODF',
  'DSIP',
  'DSCP',
]

export const noActiveVehiclesExclusionProductSubTypes = [
  'SNGLPAYLSE',
  'SPLSERP',
]

export const autoPayExclusionChatCodes = [
  'REPO',
  'REPOI',
  'PMF',
  'POF',
  'RRP',
  'BK112',
  'BK12B',
  'BK12I',
  'BK12M',
  'BK13',
  'BK13B',
  'BK13I',
  'BKACO',
  'BKC7',
  'BKNCP',
  'BKPR',
  'CED',
  'DFR',
  'STP',
  'CEXT',
  'PFS',
  'PFC',
  'BLOS',
]

export const oneTimePayExclusionChatCodes = [
  'REPO',
  'REPOI',
  'PMF',
  'POF',
  'RRP',
  'BK112',
  'BK12B',
  'BK12I',
  'BK12M',
  'BK13',
  'BK13B',
  'BK13I',
  'BKACO',
  'BKC7',
  'BKNCP',
  'BKPR',
  'CED',
  'DFR',
  'STP',
  'PFS',
  'PFC',
  'BLOS',
]
